// extracted by mini-css-extract-plugin
module.exports = {"summaryTitle":"_c500f88","freeBetIcon":"_29e4f90"};